<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from "echarts"
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '450px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.chartData)
    },
    setOptions({ timeList,totalMoneyList,commissionMoneyList, refundMoneyList,wxMoneyList,webMoneyList,alipayMoneyList,balanceMoneyList,newMoneyList } = {}) {
      this.chart.setOption({
        title: {
          text: '30日订单统计'
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: false }
          }
        },
        legend: {
          data: ['订单总金额', '佣金金额', '退款金额', '公众号支付', 'H5支付','支付宝支付','余额支付','补卡金额']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeList
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '订单总金额',
            type: 'line',
            data: totalMoneyList
          },
          {
            name: '佣金金额',
            type: 'line',
            data: commissionMoneyList
          },
          {
            name: '退款金额',
            type: 'line',
            data: refundMoneyList
          },
          {
            name: '公众号支付',
            type: 'line',
            data: wxMoneyList
          },
          {
            name: 'H5支付',
            type: 'line',
            data: webMoneyList
          },
          {
            name: '支付宝支付',
            type: 'line',
            data: alipayMoneyList
          },
          {
            name: '余额支付',
            type: 'line',
            data: balanceMoneyList
          },
          {
            name: '补卡金额',
            type: 'line',
            data: newMoneyList
          }
        ]
      });
    }
  }
}
</script>
